import { getField, updateField } from 'vuex-map-fields';
import ConfigProvider from '@/services/config.provider'
const configService = new ConfigProvider()

const initialState = {
    config_years: [],
    config_rounds: [],
    config_documents: [],
};

export const officerConfig = {
    namespaced: true,
    state: initialState,
    actions: {
        async getYears({ commit }) {
            const data = await configService.getYears();
            commit('set_years', data);
        },
        async getRounds({ commit }) {
            const data = await configService.getRounds();
            commit('set_rounds', data);
        },
        async getDocuments({ commit }) {
            const data = await configService.getDocuments();
            commit('set_documents', data);
        },
    },
    getters: {
        getField,
    },
    mutations: {
        updateField,
        set_years(state, data) { state.config_years = data },
        set_rounds(state, data) { state.config_rounds = data },
        set_documents(state, data) { state.config_documents = data },
    },
};